import * as $ from "jquery";
import { getCurrentLanguage } from '../../../../resources/typescript/Core/Languages';

export const FinalComponent = (() => {

    const Selector = {
        ORDER_NUMBER: "#final-order-number",
        ORDER_HASH: "#final-order-hash",
    };

    function sendAjaxRequestWithAcceptOrder() {
        let lang = getCurrentLanguage;
        let $orderNumber = $(Selector.ORDER_NUMBER).html();
        let $orderHash = $(Selector.ORDER_HASH).val();
        if($orderNumber !== undefined && $orderHash !== undefined) {
            $.ajax({
                url: `/${lang}/cart/accept-order/`,
                method: 'POST',
                data: {
                    order_number: $orderNumber,
                    order_hash: $orderHash
                },
                dataType: 'json',
            })
        }
    }

    $(window).on("load", sendAjaxRequestWithAcceptOrder);
})();import * as $ from "jquery";
import { getCurrentLanguage } from '../../../../resources/typescript/Core/Languages';

export const FinalComponent = (() => {

    const Selector = {
        ORDER_NUMBER: "#final-order-number",
        ORDER_HASH: "#final-order-hash",
    };

    function sendAjaxRequestWithAcceptOrder() {
        let lang = getCurrentLanguage;
        let $orderNumber = $(Selector.ORDER_NUMBER).html();
        let $orderHash = $(Selector.ORDER_HASH).val();
        if($orderNumber !== undefined && $orderHash !== undefined) {
            $.ajax({
                url: `/${lang}/cart/accept-order/`,
                method: 'POST',
                data: {
                    order_number: $orderNumber,
                    order_hash: $orderHash
                },
                dataType: 'json',
            })
        }
    }

    $(window).on("load", sendAjaxRequestWithAcceptOrder);
})();